module.exports = __webpack_public_path__ + "static/media/leaf-icon.fe8cfbcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/leaf-icon.svg
// module id = 777
// module chunks = 0